
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyB7z2LM_n6Gqzqeu7-E_ALbVlwfu18BiYk",
  authDomain: "robin-36d4d.firebaseapp.com",
  projectId: "robin-36d4d",
  storageBucket: "robin-36d4d.appspot.com",
  messagingSenderId: "687492539726",
  appId: "1:687492539726:web:98e66a91e354581837aa1f",
  measurementId: "G-24QGME6D9R"
};


const app = initializeApp(firebaseConfig);


export const db = getFirestore(app);
